import {
  ChangeDetectorRef, ChangeDetectionStrategy, Component, EventEmitter,
  Output, ViewChild, Input,
} from '@angular/core';
import * as _ from 'lodash';



import { BaseModalComponent } from 'shared/modal/_base-modal.component';
import { ModalHeaderSearchComponent } from 'shared/modal/modal-header-search/modal-header-search.component';
import { LoaderComponent } from 'shared/loader/loader.component';
import { SuggestedAttributesComponent } from '../suggested-attributes/suggested-attributes.component';
import {ProductPanelComponent} from '../../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'suggested-attributes-modal',
  templateUrl: 'suggested-attributes-modal.component.html',
  styleUrls: ['suggested-attributes-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestedAttributesModalComponent extends BaseModalComponent {

  @Input() category: string = '';
  @Input() subCategory: string = '';
  @Input() hasPartType: boolean;
  @Input() itemId: any;
  @Input() partTerminologyId: any;

  @Output() addAttributes: EventEmitter<any> = new EventEmitter();

  @ViewChild(SuggestedAttributesComponent, {static: false})
  suggestedAttributes: SuggestedAttributesComponent | void;

  @ViewChild(LoaderComponent, {static: false})
  loader: LoaderComponent | void;

  get selectedAttributes(): Array<any> {
    return _.get(this, 'suggestedAttributes.selectedRows', []);
  }

  constructor(
    private ref: ChangeDetectorRef,
  ) {
    super();
  }

  onModalHide() {
    this.hide();
  }

  onAddClick() {
    if (this.suggestedAttributes instanceof SuggestedAttributesComponent) {
      this.suggestedAttributes.excludeSelectedItems();
    }
    this.addAttributes.emit(this.selectedAttributes);
    this.hide();
  }

  public show(): void {
    super.show();
    if (this.itemId && this.partTerminologyId) {
      if (this.suggestedAttributes instanceof SuggestedAttributesComponent) {
        this.suggestedAttributes.setData(this.itemId, this.partTerminologyId);
      }
    }
  }

  public hide(): void {
    if (this.suggestedAttributes instanceof SuggestedAttributesComponent) {
      this.suggestedAttributes.resetData();
    }
    super.hide();
  }

  public removeFilters(attributesIds: Array<any>): void {
    if (this.suggestedAttributes instanceof SuggestedAttributesComponent) {
      this.suggestedAttributes.removeFilters(attributesIds);
    }
  }

  public clearFilters(): void {
    if (this.suggestedAttributes instanceof SuggestedAttributesComponent) {
      this.suggestedAttributes.clearFilters();
    }
  }
}
